import { autoserialize, inheritSerialization } from 'cerialize';
import { AbstractModel } from './abstract-model';
import { ServiceLevelConstants } from '../constants';

@inheritSerialization(AbstractModel)
export class ServiceLevel extends AbstractModel {
  @autoserialize
  name: string;

  @autoserialize
  code: string;

  @autoserialize
  description: string;

  isNonAmbulatory(): boolean {
    return (
      ServiceLevelConstants.NON_AMBULATORY_CURB_TO_CURB_CODE === this.code ||
      ServiceLevelConstants.NON_AMBULATORY_DOOR_TO_DOOR_CODE === this.code
    );
  }

  isAmbulatory(): boolean {
    return (
      ServiceLevelConstants.AMBULATORY_CURB_TO_CURB_CODE === this.code || ServiceLevelConstants.AMBULATORY_DOOR_TO_DOOR_CODE === this.code
    );
  }

  isCurbToCurb(): boolean {
    return (
      ServiceLevelConstants.AMBULATORY_CURB_TO_CURB_CODE === this.code ||
      ServiceLevelConstants.NON_AMBULATORY_CURB_TO_CURB_CODE === this.code
    );
  }
}
